/*
 *  -----------------------------------------------------------------------
 *    <copyright file="error.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import React from 'react';

export default function ({ error }: any) {
    return <div>Error: {error?.message ?? error}</div>;
}
